/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { CubeInfo } from './data-contracts'
import { HttpClient, RequestParams } from './http-client'

export class ProjectCubeClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags ProjectCube
   * @summary Получить кубы по проекту.
   * @request GET:/Seismic/project/{projectId}/cube
   * @secure
   */
  projectCubeGetCubesByProjectId = (projectId: string, params: RequestParams = {}) =>
    this.http.request<CubeInfo[], any>({
      path: `/Seismic/project/${projectId}/cube`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectCube
   * @summary Добавить куб к проекту.
   * @request POST:/Seismic/project/{projectId}/cube
   * @secure
   */
  projectCubeAddCubeToProject = (
    projectId: string,
    query: {
      /**
       * Идентификатор куба.
       * @format uuid
       */
      cubeId: string
    },
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/Seismic/project/${projectId}/cube`,
      method: 'POST',
      query: query,
      secure: true,
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectCube
   * @summary Получить одинаковые кубы проекта.
   * @request GET:/Seismic/project/{projectId}/cube/sameCubes
   * @secure
   */
  projectCubeGetSameProjectCubes = (
    projectId: string,
    query: {
      /**
       * Идентификатор куба.
       * @format uuid
       */
      cubeId: string
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CubeInfo[], any>({
      path: `/Seismic/project/${projectId}/cube/sameCubes`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectCube
   * @summary Получить кубы по проекту и горизонту.
   * @request GET:/Seismic/project/{projectId}/cube/horizon/{horizonId}
   * @secure
   */
  projectCubeGetCubesByProjectAndHorizonId = (
    projectId: string,
    horizonId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<CubeInfo[], any>({
      path: `/Seismic/project/${projectId}/cube/horizon/${horizonId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
}
